var isSearching = false; // A flag to prevent multiple submits
var readyToSubmit = false; // The onsubmit handler must not handle its own submission 
var mouse_is_inside_megamenu = false;

$(document).ready(function () {
    Cookies.set('Culture', culture);

    if (document.URL.indexOf('review') === -1 && document.cookie.indexOf('accepts_cookies') === -1) {
        $('.cookiebar-wrapper').show();
        $('.cookiebar-close').click(function () {
            var d = new Date();
            d.setTime(d.getTime() + (732 * 24 * 60 * 60 * 1000));
            document.cookie = "accepts_cookies=1;expires=" + d.toUTCString(); + ";path=/" + culture + ";";

            $('.cookiebar-wrapper').hide();
        });
    }   
     
    if (document.URL.indexOf('review') === -1 && document.cookie.indexOf('accepts_cookies') === -1) {
        $('#cookiePopupModal').modal({
            backdrop: 'static',
            keyboard: false
        })

        $('#cookiePopupModal a').click(function (e) {
            var url = $(this).attr('href') + '?frame=popup';
            $.get(url, function (result) {
                $(".modal-body #moreInfo").html(result);
                $(".modal-body #moreInfo").css({ 'height': '400px', 'border': '1px solid #eee' });
            });
            return false;
        });

        $('#cookiePopupModal').modal('show');
        $('.cookiepopup-agreed').click(function () {
            var d = new Date();
            d.setTime(d.getTime() + (732 * 24 * 60 * 60 * 1000));
            document.cookie = "accepts_cookies=1;expires=" + d.toUTCString(); + ";path=/" + culture + ";";

            $('#cookiePopupModal').modal('hide');
        });
    }

    $("a.megamenu-trigger").each(function () {
        jsHref = $(this).attr("data-jshref");

        if (jsHref != "") {
            $(this).attr("href", jsHref);
        }
    });


    $('tr[id^="cartItem-"] .remove > a').click(function (e) {
        e.preventDefault();

        var el = $(e.target).closest('tr')[0];
        AnalyticsBuilder.create(window.inTestMode ? { debug: true } : {}).addProduct({
            'name': $(el).find('.product-name-only a').text(),
            'quantity': parseInt($(el).find('.cartItem-quantity').text())
        }).asRemoveFromCart().send(function () {
            window.location = $(el).find('.remove > a')[0].href;
        });
    });

    $('.megamenu').hover(function () {
        mouse_is_inside_megamenu = true;
    }, function () {
        mouse_is_inside_megamenu = false;
    });


    $('#cart-and-userdata .country a').click(function (e) {
        $('.megamenu.fullscreen').toggleClass('opened');

        if ($('.menu-mobile').hasClass('menu-mobile-visible')) {
            $('.menu-mobile').removeClass('menu-mobile-visible');
        } else {
            $('.overlay').toggleClass('overlay-active');
        }

        $('body').toggleClass('no-scroll');

        e.preventDefault();
        return true;
    });


    $('.overlay').on('click', function () {
        if ($($('.megamenu.fullscreen').hasClass('opened'))) {
            $('.megamenu.fullscreen').removeClass('opened');
            $('.overlay').removeClass('overlay-active');
            $('body').removeClass('no-scroll');
        }
    });

    $("body").mouseup(function (e) {
        if (!mouse_is_inside_megamenu && !$(e.target).hasClass('megamenu-trigger')) {
            if ($('.megamenu-active').length > 0) {
                var code = $('.megamenu-active').attr('id').replace('megamenu', '');
                ToggleMegaMenu(code);
            }
            //$(".megamenu-active").slideUp();
            //$(".megamenu-active").removeClass("megamenu-active");
        }
    });

    $('#cacheModal').on('show.bs.modal', function (event) {
        var button = $(event.relatedTarget) // Button that triggered the modal
        var recipient = button.data('content') // Extract info from data-* attributes
        // If necessary, you could initiate an AJAX request here (and then do the updating in a callback).
        // Update the modal's content. We'll use jQuery here, but you could use a data binding library or other methods instead.
        var modal = $(this)
        modal.find('.modal-body').html(recipient);
    });

    $('.modal').on('shown.bs.modal', function (e) {
        var target = $(e.target);
        if (target.length > 0 && target[0].id != 'cacheModal') {
            var body = target.children('.modal-dialog').children('.modal-content').children('.modal-body');

            if (target.data('iframe') != undefined && target.data('iframe') !== '' && body.children().length === 0) {
                var isMobile = findBootstrapEnvironment() === 'xs';

                var height = $(window).height() - (isMobile ? 142 : 120);
                body.css({
                    overflowY: isMobile ? 'scroll' : 'hidden',
                    overflowX: 'hidden',
                    height: isMobile ? height : 'blaat',
                    width: body.width()
                });

                var element = $('<iframe style="width: 100%; height: ' + height + 'px; border:none;" src="' + target.data('iframe') + '"></iframe>');

                $(window).on('resize', function () {
                    height = $(window).height() - (isMobile ? 142 : 120);
                    $(element).css({ height: height });
                });

                body.html(element);
            }
        }

        if ($(body).find('.lazy-loading').length > 0) {
            //Trigger jquery.appear event to find and show unloaded images.
            $.force_appear();
        }
    });

    $(".fancybox").not('.fancybox-imageswiper').each(function (key, value) {
        $(value).fancybox({
            maxWidth: 1000,
            maxHeight: 1000,
            fitToView: true,
            width: '90%',
            height: '90%',
            autoSize: true,
            padding: 0,
            helpers: {
                overlay: {
                    locked: false
                }
            }
        });
    });

    $(".fancyboxSmall").each(function (key, value) {
        $(value).fancybox({
            maxWidth: 450,
            maxHeight: 420,
            fitToView: true,
            autoSize: true,
            padding: 0,
            helpers: {
                overlay: {
                    locked: false
                }
            }
        });
    });

    /************************************************
     *                                              *
     *              Bike comparison                 *
     *                                              *
     ************************************************/

    $(".compare-bar-wrapper .compare-bike").each(function () {

        var iScrollPos = 0;
        $(window).scroll(function () {
            var iCurScrollPos = $(this).scrollTop();
            if (iCurScrollPos > iScrollPos) {
                $('.compare-bar-wrapper').addClass('collapsed');
            }
            iScrollPos = iCurScrollPos;
        });
    });

    var compareTemplate =
        '<div class="compare-bike">' +
        '<button class="glyphicon glyphicon-remove remove" id="{id}" aria-label="Remove this bike from comparison"></button>' +
        '<div class="img-wrap">' +
        '<img alt="" src="{image}" />' +
        '</div>' +
        '<p class="name">{name}</p>' +
        '</div>';

    // Set's up the compare bar
    (function (storage, storageKey, template, culture) {
        "use strict"

        if (culture === 'global')
            return;

        // Doesn't support web storage API
        if (storage == undefined)
            return (console.warn.bind(console) || console.log.bind(console))
                ("Storage access denied: disabling compare functionaltity.");

        storageKey = storageKey + "_" + culture;

        var storeData = [];
        var store = window["compareStore"] = window["compareStore"] || {
            add: function (data) {
                if (!data)
                    return;

                if (storeData.length === 3) {
                    if ($('.compare-bar-wrapper').hasClass('collapsed'))
                        $('.compare-bar-wrapper').removeClass('collapsed');
                    return;
                }

                if (!this.__contains(data.id)) {
                    storeData.push(data);
                    storage.setItem(storageKey, JSON.stringify(storeData));
                }

                this.__render();

                if ($('.compare-bar-wrapper').hasClass('collapsed')
                    && !$('.compare-bar-wrapper').hasClass('no-use')
                    && !$('.compare-bar').hasClass('add-animation')) {
                    $('.compare-bar').addClass('add-animation');
                    setTimeout(function () {
                        $('.compare-bar').removeClass('add-animation');
                        HandleCompareSectionExpandedAttribute();
                    }, 1000);
                }

                ShowScreenReaderOnlyDialog('compare', 'add');

            },
            remove: function (id) {
                for (var i in storeData) {
                    if (storeData[i]["id"] === id) {
                        storeData.splice(i, 1);
                        storage.setItem(storageKey, JSON.stringify(storeData));

                        this.__render();
                    }
                }
                HandleCompareSectionExpandedAttribute();
            },
            get: function () {
                var ids = [];
                for (var i in storeData)
                    ids.push((storeData[i]["globalcatalogue"] === "True" ? "gc" : "lc") + "@" + storeData[i]["id"]);
                return ids;
            },
            __contains: function (id) {
                for (var i in storeData)
                    if (storeData[i]["id"] === id)
                        return true;
                return false;
            },
            __render: function (init) {
                for (var i = 0; i <= 3; i++) {
                    var data = storeData[i];
                    if (data !== undefined)
                        $('#compare-' + (i + 1))
                            .html(template
                                .replace(/{id}/, data["id"])
                                .replace(/{name}/, data["name"])
                                .replace(/{name}/, data["name"])
                                .replace(/{image}/, data["image"]));
                    else
                        $('#compare-' + (i + 1)).html('');
                }

                $('.compare-bar .remove').click(function (e) {
                    store.remove(Number(e.target.id));
                });

                // set count
                $('#compare-count').html(storeData.length);

                if (storeData.length > 0) {
                    setTimeout(function () {
                        $('.compare-bar-wrapper').removeClass('no-use' + (!init && storeData.length === 1 ? ' collapsed' : ''));
                        $('.skip-to-compare-wrapper').removeClass('no-use');
                        HandleCompareSectionExpandedAttribute();
                    }, 100);
                } else if (!$('.compare-bar-wrapper').hasClass('no-use')) {
                    $('.compare-bar-wrapper').addClass('no-use').addClass('collapsed');
                    $('.skip-to-compare-wrapper').addClass('no-use');
                }

                if (storeData.length > 1) {
                    $('.compare-bar .btn-compare').removeClass('disabled');
                } else if ($('.compare-bar .btn-compare').hasClass('disabled')) {
                    $('.compare-bar .btn-compare').addClass('disabled');
                }

                if (storeData.length === 3 && $('.compare-bar-wrapper').hasClass('collapsed') && !init) {
                    $('.compare-bar-wrapper').removeClass('collapsed');
                    HandleCompareSectionExpandedAttribute();
                }
            }
        };

        for (var i = 0; i < storage.length; i++) {
            var key = storage.key(i);
            if (key === storageKey) {
                storeData = JSON.parse(storage.getItem(key));
                store.__render(true);

                return;
            }
        }

        storage.setItem(storageKey, '[]');
    })((function (storageName) {
        try { return window[storageName] } catch (e) { }
    })("sessionStorage"), "Giant_ProductCompare", compareTemplate, culture);

    $('.btn-compare:not(#compare-bikes)').click(function (e) {
        e.preventDefault();

        var data = $(e.target).hasClass('glyphicon')
            ? $('.btn-compare').closest().data()
            : $(e.target).data();

        window.compareStore.add(data);

        return false;
    });

    $('#compare-bikes').click(function (e) {
        window.location = '/' + culture + '/comparison/'
            + window.compareStore.get().join('-');
    });

    $('.compare-bar .header').click(function () {
        $('.compare-bar-wrapper').toggleClass('collapsed');

        HandleCompareSectionExpandedAttribute();
     
    });

    $('#skip-to-compare').click(function () {
        $('.compare-bar-wrapper').toggleClass('collapsed');

        HandleCompareSectionExpandedAttribute();
    });

    var lastPos = 0;
    var onTimeout = false;
    $(window).scroll(function (e) {
        if (onTimeout) return;

        var pos = $(this).scrollTop();

        if (pos > lastPos && !$('.compare-bar-wrapper').hasClass('collapsed')) {
            $('.compare-bar-wrapper').addClass('collapsed');
            HandleCompareSectionExpandedAttribute();
        }
        lastPos = pos;

        // To prevent excessive performance loss
        onTimeout = true;
        setTimeout(function () {
            onTimeout = false;
        }, 50);
    });

    $('[data-fancybox="gallery"]').fancybox({
        loop: true,
        infobar: false,
        buttons: [
            //"zoom",
            //"share",
            //"slideShow",
            //"fullScreen",
            //"download",
            //"thumbs",
            "close"
        ],
        baseTpl: '<div class="fancybox-container" role="dialog" aria-modal="true" aria-label="Image gallery" tabindex="-1">' +
            '<div class="fancybox-bg"></div>' +
            '<div class="fancybox-inner">' +
            '<div class="fancybox-infobar"><span data-fancybox-index></span>&nbsp;/&nbsp;<span data-fancybox-count></span></div>' +
            '<div class="fancybox-toolbar">{{buttons}}</div>' +
            '<div class="fancybox-navigation">{{arrows}}</div>' +
            '<div class="fancybox-stage"></div>' +
            '<div class="fancybox-caption"><div class="fancybox-caption__body"></div></div>' +
            "</div>" +
            "</div>",
        afterLoad: function (instance, current) {
            current.$image.attr('alt', current.opts.$orig.find('img').attr('alt'));
        }
    });

    $('[data-type="iframe"]').fancybox({
        toolbar: false,
        smallBtn: true,
        iframe: {
            preload: false
        },
        baseTpl: '<div class="fancybox-container" role="dialog" aria-modal="true" tabindex="-1">' +
            '<div class="fancybox-bg"></div>' +
            '<div class="fancybox-inner">' +
            '<div class="fancybox-infobar"><span data-fancybox-index></span>&nbsp;/&nbsp;<span data-fancybox-count></span></div>' +
            '<div class="fancybox-toolbar">{{buttons}}</div>' +
            '<div class="fancybox-navigation">{{arrows}}</div>' +
            '<div class="fancybox-stage"></div>' +
            '<div class="fancybox-caption"><div class="fancybox-caption__body"></div></div>' +
            "</div>" +
            "</div>",
        afterShow: function (e) {
            $('.fancybox-is-open').attr('aria-label', e.$trigger[0].outerText);
        }
    })


    //$(".galleryzoom").fancybox({
    //    'zoomOpacity': true,
    //    'overlayShow': false,
    //    'zoomSpeedIn': 500,
    //    'zoomSpeedOut': 500,
    //    helpers: {
    //        overlay: {
    //            locked: false
    //        }
    //    },
    //    afterShow: function () {
            
    //        // focus to close link
    //        var objClose = $("a.fancybox-close"); 
    //        $(objClose).focus();

    //        // store opener id in hidden input
    //        var galleryItemId = this.element.attr("data-galleryitemid");
    //        $("input#fancyboxOpenerId").val(galleryItemId);

    //        // add class to body
    //        $("body").addClass("gallery-zoom-active");

    //        //A360
    //        openDialog($('.fancybox-wrap')[0]);

    //        //A360
    //        $('.fancybox-opened').attr('role', 'dialog');
    //        $('.fancybox-opened').attr('aria-modal', 'true');
    //        $('.fancybox-opened').attr('aria-label', 'Image Gallery');
    //    },
    //    afterClose: function () {
    //        // add class to body
    //        $("body").removeClass("gallery-zoom-active");
    //        // back to opener
    //        var openerId = $("input#fancyboxOpenerId").val();
    //        var openerElement = $("#gallery .thumb a[data-galleryitemid='" + openerId + "']"); 
    //        if (openerElement != null) {
    //            $(openerElement.get(0)).focus();
    //        }

    //        //A360
    //        closeDialog();
    //    }
        
    //});

    //$(".fancybox").fancybox({
    //    afterShow: function (e) {
    //        openDialog($('.fancybox-wrap')[0]);
    //        // focus to close link
    //        var objClose = $("a.fancybox-close");
    //        $(objClose).focus();

    //        $('.fancybox-opened').attr('role', 'dialog');
    //        $('.fancybox-opened').attr('aria-modal', 'true');
    //        try {
    //            $('.fancybox-opened').attr('aria-label', $(this)[0].element[0].outerText);
    //        } catch (e) {
    //            //do nothing
    //        }
    //    },
    //    afterClose: function (e) {
    //        closeDialog();
    //        e.element[0].focus();
    //    }

    //}); 



    /* ACT LIKE TAB CLICK */
    $("a.act-like-tab-click").click(function (event) {

        // get target
        myHref = $(this).attr("href");

        // prevent anchor link
        event.preventDefault();

        // set link state
        $(".scrollmenu a").removeClass("active");
        // activate
        var linkId = myHref.replace("#", "");
        $(".scrollmenu a#scrollmenu-" + linkId).addClass("active");

        //scroll
        ScrollToTarget(myHref);

        // set focus to target
        $("div" + myHref).focus();
    });


    /* CALLOUTS */
    $("button.callout-link").click(function () {

        var yPosLink = 0;

        // set all links to default
        $("button.callout-link").removeClass("callout-link-active");

        // get id of infoblock
        myId = this.id;
        divId = myId.replace("link", "info");

        // get rel
        myRel = $(this).attr("rel");

        // check if click to show or click to hide
        if ($("div#" + divId).is(":visible"))
        {
            $(this).removeClass("callout-link-active");
            // close this one
            $("div#" + divId).fadeOut('fast');
            $(this).text(myRel);
            // a360
            $(this).attr("aria-expanded", "false");
        }
        else
        {

            // add active
            $(this).addClass("callout-link-active");

            // hide all other info blocks
            $("div.callout-info").fadeOut();

            // show this one
            $("div#" + divId).fadeIn();

            // a360
            $(this).attr("aria-expanded", "true");
            
            // set position of infoblock
            yPosLink = $(this).position().top;

            var yPosDiv = yPosLink + 22;
            $("div#" + divId).css({ top: yPosDiv + 'px' });

            // change link text
            $(this).text("X");

            // change other link texts back to number
            $("button.callout-link").each(function () {
                loopId = this.id;
                numberText = $(this).attr("rel");
                if (loopId != myId) {
                    $(this).text(numberText);
                }
            });

        }

    });

    // SK: reposition callouts based on css image size
    $(".callout-link").each(function () {

        var originalWidth = 970;
        var imageWidth = $("#highlights .image img").width();

        if (imageWidth < originalWidth) {

            var factor = (imageWidth / originalWidth);

            // get original positions
            var originalTop = $(this).attr("data-originaltop");
            var originalLeft = $(this).attr("data-originalleft");

            // define new position
            var newTopValue = originalTop * factor;
            var newLeftValue = originalLeft * factor;
            if (imageWidth == 500) {
                newLeftValue = newLeftValue + 30
            } else {
                newLeftValue = newLeftValue - 30;
            }
          
            // set position
            $(this).css('top', newTopValue);
            $(this).css('left', newLeftValue);

        }

    });

    var matchList = new Bloodhound({
        datumTokenizer: Bloodhound.tokenizers.obj.whitespace('SmartSearchDto'),
        queryTokenizer: Bloodhound.tokenizers.whitespace,
        limit: 100,
        remote: {
            //url: 'http://localhost:59019/api/smartsearch/search?searchTerm=%QUERY',
            url: '/' + culture + '/search/jsonsearch?keyword=%QUERY',
            wildcard: '%QUERY'
        }
    });
    matchList.initialize();

    $("input#search").typeahead({
        hint: false,
        minLength: 3,
    },
        {
            templates: {
                suggestion: function (data) {
                    var item = data.Title;
                    var html = $('<div></div>');
                    var query = data._query;
                    try {
                        var i = item.toString().toLowerCase().indexOf(query.toLowerCase());
                    } catch (e) {

                    }
                    var len, leftPart, middlePart, rightPart, strong;
                    len = query.length;
                    while (i > -1) {
                        leftPart = item.substr(0, i);
                        middlePart = item.substr(i, len);
                        rightPart = item.substr(i + len);
                        strong = $('<strong></strong>').text(middlePart);
                        html
                            .append(document.createTextNode(leftPart))
                            .append(strong);
                        item = rightPart;
                        i = item.toString().toLowerCase().indexOf(query.toLowerCase());
                    }
                    var result = '<p>' + html.append(document.createTextNode(item)).html()
                    if (data.SubTitle.length > 0) { result += ' - ' + data.SubTitle }
                    result += "</p>";
                    return result;
                }
            },
            source: matchList.ttAdapter(),
            displayKey: 'Title',
            limit: 100000
        });

    $("input#search").bind('typeahead:selected', function (obj, item) {
        window.location = item.Url;
    });

    $("body .header-search input").click(function () {
        $("body .header-search").addClass("header-search-active");
    });
    $("body a.hide-expanded-search").click(function () {
        $("body .header-search").removeClass("header-search-active");
    });


    $("header .header-search a.search-submit").click(function () {
        var inputValue = $("input#search").val();
        if (inputValue != "") {
            $("header .header-search form").submit();
        }
        else {
            $("body .header-search").addClass("header-search-active");
        }
    });

    $('.campaignPopover').popover();

    $('body').on('mouseover', '.campaignPopover', function (e) {
        $(this).popover('show');
    });
   
    $('.btn-enable-progress').click(function () {
        $(this).addClass('btn-run-progress');
    });

    $("a.toggle-video").click(function () {
        $(this).parent().parent().parent().addClass("content-wrapper-video-playing");
        $(this).hide();
        myId = this.id;

        // hide link
        iframeId = myId.replace("toggle-", "");

        // show iframe
        $("iframe#" + iframeId).show();

        // autoplay
        iframeSrc = $("iframe#" + iframeId).attr("src");
        $("iframe#" + iframeId).attr("src", iframeSrc + "&autoplay=1");

    });

    $("a.setMainImage").click(function () {
        // get new main image src
        var myRel = $(this).attr("rel");

        // get loopindex attr
        var loopIndex = $(this).data("loopindex");
        $('img[name="mainImage"]').parent().data('slide', loopIndex);
        objImage = $('img[name="mainImage"]')
            .attr('src', myRel);
    });

    $('.getContactForm').click(function () {
        $('#contactModal').modal('show');
    });


    $('.getstockalert').click(function () {
        $('#stockAlertModal #partnumberCode').val($(this).attr('data-partnumbercode'));
        $('#stockAlertModal').modal('show');
    });

    $('#sendStockAlert').click(function () {
        $('#stockAlertModal .alert').remove();
        $.ajax({
            type: 'POST',
            url: '/' + culture + '/shop/stockalert',
            data: { partnumberCode: $('#partnumberCode').val(), email: $('#Email').val(), zipcode: $('#Zipcode').val() },
            success: function (data) {
                if (data == "True") {
                    $('#stockAlertModal').modal('hide');
                } else {
                    $('#stockAlertModal .modal-body').prepend('<div class="alert alert-danger">' + data + '</div>');
                }
            }
        });
    });

    $("#inputFindLocalStock").keydown(function (event) {
        if (event.keyCode == 13) {
            $("#btnFindLocalStock").trigger("click");
            return false;
        }
    });

    $('body').on('click', '.btn-findLocalstock,#findLocalStock', function () {
        $('#ModalLocalStockFinder').modal('show');
    });


    if (isMobile()) {
        $('.panel-default').on('shown.bs.collapse', function (e) {
            var $panel = $(e.target).parent('.panel');
            var extraOffset = 68;

            setTimeout(function () {
                $('html,body').animate({
                    scrollTop: $panel.offset().top - extraOffset
                }, 750);
            }, 400);
        });
    }

    $('.panel-collapse').on('show.bs.collapse', function () {
        $('.panel-collapse').collapse('hide');
    })

    $('input[name="agreeToTermsAndConditions"]').change(function (e) {
        var filtered = $('input[name="agreeToTermsAndConditions"]').not(this);
        var val = this.checked;
        filtered.prop('checked', val);
    });

    $('.birthday').datetimepicker({
        viewMode: 'years',
        format: 'L',
        maxDate: new Date((new Date().getFullYear() - 10), 1, 1),
        locale: cultureFull
    });

    $('.birthdayShop').datetimepicker({
        viewMode: 'years',
        format: 'L',
        locale: cultureFull,
        minDate: new Date((new Date().getFullYear() - 119), 1, 1),
        maxDate: new Date()
    }).on('dp.change', function (e) {
        var element = angular.element($(this));
        var controller = element.controller();
        var scope = element.scope();
        scope.Cart.Order.BirthDateISO = e.date.format('YYYY-MM-DD');
        scope.$apply();
        $('#BirthDateISO').val(e.date.format('YYYY-MM-DD'));
    });

    $('.birthdayAccount').datetimepicker({
        viewMode: 'years',
        format: 'L',
        locale: cultureFull,
        minDate: new Date((new Date().getFullYear() - 119), 1, 1)
        // maxDate: today
    }).on('dp.change', function (e) {
        var element = angular.element($(this));
        var controller = element.controller();
        var scope = element.scope();
        scope.Account.BirthDateISO = e.date.format('YYYY-MM-DD');
        scope.$apply();
        $('#BirthDateISO').val(e.date.format('YYYY-MM-DD'));
    });

    $('.birthdayRegistration').datetimepicker({
        viewMode: 'years',
        format: 'L',
        locale: cultureFull,
        minDate: new Date((new Date().getFullYear() - 119), 1, 1),
        maxDate: new Date()
    }).on('dp.change', function (e) {
        var element = angular.element($(this));
        var controller = element.controller();
        var scope = element.scope();
        scope.Registration.Registration.BirthDateISO = e.date.format('YYYY-MM-DD');
        scope.$apply();
        $('#BirthDateISO').val(e.date.format('YYYY-MM-DD'));
    });

    $('.datetimeRegistration').datetimepicker({
        maxDate: new Date(),
        format: 'L',
        locale: cultureFull,
        minDate: new Date((new Date().getFullYear() - 119), 1, 1),
        maxDate: new Date()
    }).on('dp.change', function (e) {
        var element = angular.element($(this));
        var controller = element.controller();
        var scope = element.scope();
        scope.Registration.Registration.BuyDateISO = e.date.format('YYYY-MM-DD');
        scope.$apply();
        $('#BuyDateISO').val(e.date.format('YYYY-MM-DD'));
    });

    $('.senddate').datetimepicker({
        format: 'L',
        locale: cultureFull,
        minDate: new Date()
    }).on('dp.change', function (e) {
        var element = angular.element($(this));
        var controller = element.controller();
        var scope = element.scope();
        scope.GiftcardSenddate = e.date.format('YYYY-MM-DD');
        scope.$apply();
        $('#senddate').val(e.date.format('YYYY-MM-DD'));
    });

    $('.datetime').datetimepicker({
        maxDate: new Date(),
        format: 'L',
        locale: cultureFull
    });

    $('a#toggle-storefilters').click(function () {
        $("div.storefilters div").slideToggle();
    });

    //new SwipeGallery('.swipe-base', '.gallery-item');

    $(".paymentContainer input.payment-option-radio").change(function () {

        // get value
        clickedValue = $(this).val();

        // toggle classes
        $(".paymentOption").addClass("paymentOption-inactive");
        $(".paymentOption-" + clickedValue).removeClass("paymentOption-inactive");

    });


    $(".faq-boxes li a").click(function () {

        // remove active
        $(".faq-box").removeClass("active");
        $(".faq-box").attr("aria-selected", "false");
        $(".faq-box").attr("aria-tabindex", "-1");

        $(".faq-answer").hide();
        $(".faq-answer").attr("tabindex", "-1");
      
        $(this).addClass("active");
        myId = this.id;
        divId = myId.replace("faq-box", "faq-answer");

        // set active index
        myIndex = $(this).attr("data-index");
        activeFaqIndex = myIndex;

        // slide
        $("#" + divId).slideDown();
        // set tabindex
        $("#" + divId).attr("tabindex", "0")
        // set aria selected
        $(this).attr("aria-selected", "true")

        // scroll
        var newPosition = $(".answers").offset().top;
        $('html, body').animate({
            scrollTop: newPosition - 150
        }, 1000);

    });


    $('form#Geocoder').submit(function (e) {
        //console.log($(this).serialize());
        if ($('#latlng').val() != '') {
            return true;
        } else {
            e.preventDefault();
            return false;
        }
    });


    $("button.toggle-unit").click(function () {

        // toggle button class
        $("button.toggle-unit").toggleClass("toggle-unit-active");
        $("button.toggle-unit").toggleClass("selected");

        // aria
        $("button.toggle-unit").attr("aria-pressed", "false");
        $(this).attr("aria-pressed", "true");
        $("button.toggle-unit").attr("aria-selected", "false");
        $(this).attr("aria-selected", "true");

        // toggle values for unit
        $("span.value-mm").toggle();
        $("span.value-inch").toggle();
        $("span.inch-label").toggle();
        $("span.mm-label").toggle();
        $("span.value-km").toggle();
        $("span.value-miles").toggle();

    });

    //show swipe hand symbol on mobile
    $(".icon-hand-swipe").each(function () {
        var myHandIcon = this;

        $(".icon-hand-swipe-container").scroll(function () {
            // get id
            var divId = this.id;
            // get scroll value
            var scrollValue = $(this).scrollLeft();
            if (scrollValue > 0) {
                // wait and fade out
                setTimeout(function () {
                    $("#" + divId + " .icon-hand-swipe").addClass("fadeout");
                }, 100);
            }
        });

    });


    $('a#link-serviceappointmentmodal').click(function () {
        var currentWindowHeight = $(window).height();
        $("iframe#planitiframe").css('height', currentWindowHeight * 0.75 | 0);
    });

    $('#contactForm').on('submit', function (e) {
        e.preventDefault();
        grecaptcha.ready(function () {
            grecaptcha.execute(window.GoogleRecaptchaSiteKey, { action: 'social' })
                .then(function (token) {
                    $('#recaptchaToken').val(token);
                    e.currentTarget.submit();
                });
        });
    });

    // toggle mobile menu
    $('button#toggle-menu').click(function () {

        var isAlreadyOpen = $("body").hasClass('show-mobile-menu');
        if (isAlreadyOpen) {
            // CLOSE MOBILE MENU
            $(this).removeClass('open');
            $(this).attr("aria-expanded", "false"); //A360 Issue 340: fix for screenreaders
            // add class to body
            $("body").removeClass('show-mobile-menu');
            // show overlay
            $(".overlay").removeClass('overlay-active');
          
        }
        else {
            // OPEN MOBILE MENU
            $(this).addClass('open');
            $(this).attr("aria-expanded", "true"); //A360 Issue 340: fix for screenreaders
            // add class to body
            $("body").addClass('show-mobile-menu');
            // show overlay
            $(".overlay").addClass('overlay-active');
           
        }

    });

    // header/brandswitch ONLOAD
    HandleScrollingAndScaling(this);

    // header+brandswitch ONSCROLL
    $(window).on("scroll", function () {
        HandleScrollingAndScaling(this);
    });
    $(window).on('resize', function () {
        HandleScrollingAndScaling(this);
    });

    // megamenu
    $(".toggle-megamenu").click(function () {

        var menuId = $(this).attr("data-menuid");
        var isVisible = $('#' + menuId).is(':visible');

        // hide others
        $("a.toggle-megamenu").attr("aria-expanded", "false");
        $(".megamenuactive").removeClass("megamenuactive");
        $(".toggle-megamenu").removeClass("active");

        if (isVisible) {
            // hide megamenu
            $("#" + menuId).removeClass("megamenuactive");
            // hide overlay
            $(".overlay").removeClass("overlay-active");
            // remove body megameny class 
            $("body").removeClass("megamenu-open");

        } else {
            // show megamenu
            $("#" + menuId).addClass("megamenuactive");
            // show overlay
            $(".overlay").addClass("overlay-active");
            // add class to body for mobile scrolling
            $("body").addClass("megamenu-open");
            // add active class to link itself
            $(this).addClass("active")
            // aria 
            $(this).attr("aria-expanded", "true");
            // add focus
            if (menuId == "megamenusearch") {
                $("#megamenusearch form input").focus();
            }
        }
    });

    $(".close-megamenu a").click(function () {
        $(".megamenuactive").removeClass("megamenuactive");
        // body
        $("body").removeClass("megamenu-open");
        // hide overlay
        $(".overlay").removeClass("overlay-active");
    });

    $('[data-analytics-link]').click(function (e) {
        var preferences = window.GDPRactive == true ? $.gdprcookie.preference() : false;
        if (window.GDPRactive == false || (preferences != false && preferences.indexOf('essential') > -1)) {
            if (!ga.loaded)
                return;
            e.preventDefault();

            var $link;
            if ($(e.target).is('[data-analytics-link]'))
                $link = $(e.target);
            else
                $link = $(e.target).closest('[data-analytics-link]');

            window["AnalyticsBuilder"].create(window.inTestMode ? { debug: true } : {})
                .addProduct(createProduct($link.data()))
                .asClick($link.data('analyticsLink'))
                .send(function () {
                    window.location = $link[0].href;
                });
            console.log("*GDPR-essential: data-analytics-link");
        }
    });

    $('[data-analytics-impression]').each(function (i, e) {
        var preferences = window.GDPRactive == true ? $.gdprcookie.preference() : false;
        if (window.GDPRactive == false || (preferences != false && preferences.indexOf('essential') > -1)) {
            var impression = createProduct($(e).data());
            impression['list'] = $(e).data('analyticsImpression');
            impression['position'] = i + 1;
            impression['list_name'] = $(e).data('analyticsImpression');
            impression['list_position'] = i + 1;

            window["AnalyticsBuilder"].create(window.inTestMode ? { debug: true } : {})
                .addImpression(impression)
                .send();
            console.log("*GDPR-essential: data-analytics-impression");
        }
    });

    //$('[data-analytics-event]').click(function (e) {
    //    var preferences = window.GDPRactive == true ? $.gdprcookie.preference() : false;
    //    if (window.GDPRactive == false || (preferences != false && preferences.indexOf('essential') > -1)) {
    //        var $target = $(e.target).is('[data-analytics-event]') ? $(e.target)
    //            : $(e.target).closest('[data-analytics-event]');

    //        window["AnalyticsBuilder"].create(window.inTestMode ? { debug: true } : {})
    //            .asEvent().send({
    //                type: 'event',
    //                category: $target.data('analyticsEvent'),
    //                action: 'Click',
    //                label: $target.data('analyticsLabel')
    //            });
    //        console.log("*GDPR-essential: data-analytics-event");
    //    }
    //});

    isMobile = function () {
        var isMobile = window.matchMedia("only screen and (max-width: 760px)");
        return isMobile.matches ? true : false
    }

    // desktop - so replace placeholder div with embed
    $(".banner-video-enable-mobile-switch").each(function () {

        // get image
        var dataVideoPlaceholderImage = $(this).attr("data-videoplaceholderimage");
        var dataVideoPlaceholderImageDesktop = $(this).attr("data-videoplaceholderimagedesktop");
        var dataVideoProvider = $(this).attr("data-videoprovider");
        var dataActivateVideoOnMobile = $(this).attr("data-activatevideoonmobile");

        if (isMobile() && dataActivateVideoOnMobile == "False") {
            // change class
            $(this).addClass("banner-video-mobile-mode");

            // set mobile image
            $(this).css("background-image", "url('" + dataVideoPlaceholderImage + "')");

        }
        else {
            var dataVideoUrl = $(this).attr("data-videourl");
            var dataVideoCode = $(this).attr("data-videocode");
            var dataAutoPlay = $(this).attr("data-autoplay");
            var dataVideoTitle = $(this).attr("data-videotitle");
            var dataAltText = $(this).attr("data-alttext");

            var autoplayValue = dataAutoPlay != "" ? dataAutoPlay : "1";

            if (dataVideoProvider == "Youtube") {
                // ---------------Youtube ------------------

                var youtubeEmbedUrl = "https://www.youtube.com/embed/" + dataVideoCode + "?controls=0&showinfo=0&rel=0&autoplay=" + autoplayValue + "&mute=0&loop=1&cc_load_policy=0&playlist=7BffwUQRBGI&enablejsapi=1&origin=https%3A%2F%2Fwww.giant-bicycles.com&widgetid=1";
                var videoHtml = '';
                videoHtml += '<div class="video-wrapper-outer">';
                videoHtml += '<div class="video-wrapper-inner">';
                videoHtml += '<div class="video-iframe-container" style="height:100%;left:0;position:absolute;top:0;width:100%;z-index:200">';
                videoHtml += '<span class="sr-only">' + dataAltText +'</span>';
                videoHtml += '<iframe width="560" height="315" src="' + youtubeEmbedUrl + '" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen style="width:100%;height:100%;"></iframe>';
                videoHtml += '</div>';
                videoHtml += ' </div>';
                videoHtml += '</div>';

                $(this).prepend(videoHtml);

            }
            else if (dataVideoProvider == "Wistia") {
                // ------------------- Wistia -------------------
                if (GDPRactive) {
                    window._wq = window._wq || [];
                    window._wq.push(function (W) {
                        W.consent(false);
                        console.log("*GDPR-essential: Wistia consent is set to", W.consent()); // returns true or false
                    });
                }

                // WISTIA 
                console.log("*GDPR-essential: Wistia")
                loadExternalScript("//fast.wistia.net/assets/external/E-v1.js");
                var wistiaEmbedUrl = "https://fast.wistia.net/embed/iframe/" + dataVideoCode + "?videoFoam=true";
                var videoHtml = '';
                videoHtml += '<div class="content-wrapper content-wrapper-wistia-embed video-cinema-format">';
                videoHtml += '<div class=wistia_responsive_padding>';
                videoHtml += '<div class=wistia_responsive_wrapper style="height:100%;left:0;position:absolute;top:0;width:100%;z-index:200">';
                videoHtml += '<span class="sr-only">' + dataAltText + '</span>';
                videoHtml += '<iframe src="' + wistiaEmbedUrl + '" title="' + dataVideoTitle +'" allowtransparency=true frameborder=0 scrolling=no class=wistia_embed name=wistia_embed allowfullscreen mozallowfullscreen=true webkitallowfullscreen=true oallowfullscreen=true msallowfullscreen=true width=100% height=100%></iframe>';
                videoHtml += '</div>';
                videoHtml += '</div>';
                videoHtml += '</div>';

                $(this).prepend(videoHtml);
            }
            else {
                // --------------------- Hosted Video -----------------

                var videoHtml = '';
                videoHtml += '<div class="video-wrapper-outer">';
                videoHtml += '<div class="video-wrapper-inner">';
                videoHtml += '<div class="video-iframe-container" style="height:100%;left:0;position:absolute;top:0;width:100%;z-index:200">';
                videoHtml += '<span class="sr-only">' + dataAltText + '</span>';
                videoHtml += '<video id="video" preload="auto" poster="' + dataVideoPlaceholderImageDesktop + '" loop="" autoplay="" muted="" volume="0.0" style="width:100%;height:100%;">';
                videoHtml += '<source src="' + dataVideoUrl + '" type="video/mp4"/>';
                videoHtml += 'Video not supported ';
                videoHtml += '</video>';
                videoHtml += '</div>';
                videoHtml += '</div>';
                videoHtml += '</div>';

                $(this).prepend(videoHtml);
            }

        }

    });

    $('.lazy-loading').appear();
    $('.lazy-loading').on('appear', function (event, $all_appeared_elements) {
        // this element is now inside browser viewport
        $all_appeared_elements.each(function () {
            LazyLoadImage(this);
            //if (($(this).attr('src') == undefined || $(this).attr('src').length == 0 || $(this).attr('src').indexOf('Spacer') > -1 || $(this).attr('src').indexOf('placeholder') > -1 || $(this).is("source")) && $(this).attr('data-src')) {
            //    console.log('Image loaded: ' + $(this).attr('data-src'));
            //    if (this.nodeName == 'DIV' || this.nodeName == 'PICTURE' || this.nodeName == 'LI') {
            //        $(this).css('background-image', 'url(' + $(this).attr('data-src') + ')')
            //    } else if ($(this).is("source")) {
            //        $(this).attr('srcset', $(this).attr('data-src'));
            //    } else {
            //        this.src = $(this).attr('data-src');
            //    }
            //}
        });
    });

    $('#gallery').appear();
    $('#gallery').one('appear', function (event, $all_appeared_elements) {
        new SwipeGallery('.swipe-base', '.gallery-item');
    });
    
    $.force_appear();


    $(".toggle-price-info-popup").click(function () {
        if ($(".price-info-popup").is(":visible")) {
            $(".price-info-popup").hide();
            $(this).attr("aria-expanded", "false");
        } else {
            $(".price-info-popup").show();
            $(this).attr("aria-expanded", "true");
        }
       
    });


    // momentum responsive carousel experiment
    $(".carousel-wrapper-responsive").each(function () {

        //console.log("found responsive carousel");

        // first show placeholder
        $(".placeholder").show();
        // hide carousel list old html
        $(".carousel-wrapper-responsive ul").html("");

        // get window width
        var myWindowWidth = $(window).width();
        console.log("myWindowWidth: " + myWindowWidth);

        // get total number of items
        var nrOfItems = jsonCarouselItems.length;
        console.log("nrOfItems: " + nrOfItems);

        // calculate number of items per slide
        var nrOfItemsPerSlide = myWindowWidth < 768 ? 1 : myWindowWidth < 1024 ? nrOfItemsPerSlide768 : nrOfItemsPerSlide1024;
        console.log("nrOfItemsPerSlide: " + nrOfItemsPerSlide);

        // how many slides for nr of tiles
        var nrOfSlides = Math.ceil(nrOfItems / nrOfItemsPerSlide);
        console.log("nrOfSlides: " + nrOfSlides);

        // create nr of lists
        var itemIndex = 0;
        var htmlToAppend = "";
        for (i = 1; i <= nrOfSlides; i++) {

            // start with <li> open tag and <div class='row'> for bootstrap grid
            var liHtml = "<li class='pane"+ i +" regular'><div class='row'>";
                
            // add col divs
            for (s = 0; s < nrOfItemsPerSlide; s++)
            {
                // if index is above max then start again
                if (itemIndex >= nrOfItems) {
                    itemIndex = 0;
                }

                // debug
                console.log("add item [" + itemIndex + "] to slide nr: " + i);

                // get item
                var objItem = jsonCarouselItems[itemIndex];
                var imageSrc = objItem.image;
                var title = objItem.title;

                // create div-html 
                var divHtml = "";
                divHtml += "<div class='col-tile col-lg-3 col-md-4 col-sm-6 col-xs-12'>";
                divHtml += "<div class='image'>";
                divHtml += "<img src='"+ imageSrc  +"'/>";
                divHtml += "</div>";
                divHtml += "<div class='text'>";
                divHtml += "<h3>"+ title +"</h3>";
                divHtml += "</div>";
                divHtml += "</div>";

                // append to li
                liHtml += divHtml;

                // add up index
                itemIndex = itemIndex + 1;
            }

            liHtml += "</div></li>";

            // append to html
            htmlToAppend += liHtml;

        }

        // replace with clean li 
        $(".carousel-wrapper-responsive ul").html(htmlToAppend);

        // initalize
        var carouselBanner = new Carousel("#carousel-topsellers");
        carouselBanner.init();

        // hide placeholder
        $(".placeholder").hide();
   
    });


    //// GALLERY 360: keep focus inside modal
    //document.addEventListener('keydown', function (e) {

    //    if ($("body").hasClass("gallery-zoom-active")) {

    //        var focusedElement = document.activeElement;
    //        var focusedTabIndex = $(focusedElement).attr("tabindex");
    //        var firstFocusableElement = $("a.fancybox-close");
    //        var lastFocusableElement = $("a.fancybox-prev");
    //        var isTabPressed = (e.key === 'Tab' || e.keyCode === 9);

    //        if (e.keyCode == 37)
    //        {
    //            $.fancybox.prev();
    //        }
    //        else if (e.keyCode == 39)
    //        {
    //            $.fancybox.next();
    //        }
    //        else if (!isTabPressed) {
    //            return;
    //        }

    //        if (e.shiftKey) {
    //            // shift tab (reverse)
    //            if (focusedTabIndex == "1") {
    //                // dan naar 3
    //                lastFocusableElement.focus();
    //                e.preventDefault();
    //            }
    //        } else {
    //            // tab
    //            if (focusedTabIndex == "3") {
    //                firstFocusableElement.focus();
    //                e.preventDefault();
    //            }
    //        }
    //    }
    //});

    //var modalInitiator;
    $('.modal').on('shown.bs.modal', function (e) {
        //A360 make sure all elements outside modal have tabindex -1 + set focus to close button 
        openDialog($(this)[0]);
        $(this)[0].querySelectorAll('button')[0].focus();
        //modalInitiator = e.relatedTarget;
    });
    $('.modal').on('hidden.bs.modal', function (e) {
        //A360 make sure all elements outside modal have tabindex -1
        closeDialog();
        //modalInitiator.focus();
        //Array.from(modalInitiator.querySelectorAll('*'))[0].focus();
        //$(modalInitiator)[0].querySelectorAll('*')[0].focus();
    });


    $('#closeDevtools').click(function () { Cookies.set('showDevToolsDefault', false); });
    $('#showDevtools').click(function () { Cookies.set('showDevToolsDefault', true); });

    // new zoom
    $("#mainImage button").click(function () {
        var zoomImageSrc = $(this).attr("data-zoomsrc");
        // show zoom div
        $(".zoomed-image-modal").addClass("zoomed-image-modal-active");
        $(".zoomed-image-modal img").attr("src", zoomImageSrc);

        openDialog($(".zoomed-image-modal")[0]);

        setTimeout(function () { $("#close-zoomed-image-modal").focus(); }, 1000);
    });

    $("button.close-zoomed-image-modal, img.zoomed-image").click(function () {
        $(".zoomed-image-modal").removeClass("zoomed-image-modal-active");
        $(".zoomed-image-modal img").attr("src", "");
        closeDialog();
        setTimeout(function () { $("#mainImage button").focus(); }, 1000);
    });

    $(".content-wrapper-topbaritems .item-trigger-button .trigger").click(function () {
        var triggerId = $(this).attr("data-triggerid");
         $("button#" + triggerId).trigger("click");
    });

    /* floating labels - blur and focus */
    $(".wrapper-floating-label input").on('focus', function () {
        // FOCUS
        $(this).closest(".wrapper-floating-label").addClass("active");
        // always move label
        $(this).closest(".wrapper-floating-label").addClass("movelabel");
      
    }).bind('blur', function () {
        // BLUR
        $(this).closest(".wrapper-floating-label").removeClass("active");
        // move label
        var myValue = $(this).val();
        if (myValue == '') {
            $(this).closest(".wrapper-floating-label").removeClass("movelabel"); 
        }
    });

    // floating labels - on load
    $(".wrapper-floating-label input").each(function () {
        var myValue = $(this).val();
        if (myValue != '') {
            $(this).parent().addClass("movelabel");
        }
    });

    $(".wrapper-floating-label input").change(function () {
        var myValue = $(this).val();
        if (myValue != '') {
            $(this).parent().addClass("movelabel");
        }
    });

    $(".tile .article-linked").click(function () {
        var dataLinkUrl = $(this).attr("data-linkurl");
        var dataLinkTarget = $(this).attr("data-linktarget");
        // go
        window.open(dataLinkUrl, dataLinkTarget); 
    });

    $(function () {
        var numberOfImages = 36;
        var currentImagePosition = 5;
        var imgNumString = '';

        $("#rotate360ImgLeft").click(function () {
            if (currentImagePosition > 1) {
                currentImagePosition--;
            } else {
                currentImagePosition = numberOfImages;
            }

            if (currentImagePosition < 10) {
                imgNumString = '0' + currentImagePosition.toString();
            } else {
                imgNumString = currentImagePosition.toString();
            }

            // change the image src
            document.getElementById("myImg").src = imageFolder + "/" + imgNumString + "_" + imageFileNameBase + ".jpg";
        });

        $("#rotate360ImgRight").click(function () {
            if (currentImagePosition < numberOfImages) {
                currentImagePosition++;
            } else {
                currentImagePosition = 1;
            }

            if (currentImagePosition < 10) {
                imgNumString = '0' + currentImagePosition.toString();
            } else {
                imgNumString = currentImagePosition.toString();
            }

            // change the image src
            document.getElementById("myImg").src = imageFolder + "/" + imgNumString + "_" + imageFileNameBase + ".jpg";
        });
    });

});

